import { Button, Card, Checkbox, Col, DatePicker, Form, FormInstance, Input, Row } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";

interface ExperienceFormProps {
  form: FormInstance;
}

const ExperienceForm: React.FC<ExperienceFormProps> = ({ form }) => {
  return (
    <Form.List name="experience">
      {(fields, { add, remove }) => (
        <div style={{ display: "flex", rowGap: 16, flexDirection: "column" }}>
          {fields.map((field) => (
            <Card
              size="small"
              title={`Experience ${field.name + 1}`}
              key={field.key}
              extra={
                <CloseOutlined
                  onClick={() => remove(field.name)}
                />
              }
            >
              <Row gutter={[48, 32]}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <Form.Item
                    name={[field.name, "title"]}
                    label="Title"
                    rules={[{ required: true, message: "Title is required" }]}
                  >
                    <Input placeholder="e.g. Software Engineer" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <Form.Item
                    name={[field.name, "company"]}
                    label="Company Name"
                    rules={[{ required: true, message: "Company is required" }]}
                  >
                    <Input placeholder="e.g. Tech Solutions Pvt Ltd" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <Form.Item
                    name={[field.name, "location"]}
                    label="Location"
                    rules={[{ required: true, message: "Location is required" }]}
                  >
                    <Input placeholder="e.g. Kathmandu" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <Form.Item
                    name={[field.name, "startDate"]}
                    label="Start Date"
                    rules={[{ required: true, message: "Start date is required" }]}
                  >
                    <DatePicker className="w-full" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <Form.Item
                    name={[field.name, "endDate"]}
                    label="End Date"
                  >
                    <DatePicker
                      className="w-full"
                      disabledDate={(current) => {
                        const startDate = form.getFieldValue(["experience", field.name, "startDate"]);
                        if (!startDate) return false;
                        return current && current.isBefore(startDate, "day");
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item
                    name={[field.name, "descriptions"]}
                    label="Description"
                    rules={[{ required: false }]}
                  >
                    <ReactQuill placeholder="Type here..." theme="snow" style={{ height: "180px" }} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name={[field.name, "currentlyWorking"]} valuePropName="checked">
                    <Checkbox>Currently Working Here</Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          ))}

          {fields.length < 6 && (
            <Button type="dashed" onClick={() => add()} block>
              + Add more
            </Button>
          )}


        </div>
      )}
    </Form.List>
  );
};

export default ExperienceForm;
